// src/components/GeneralDataGrid.jsx
import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const GeneralDataGrid = ({ columns, rows, checkboxSelection, height, sx }) => {
  return (
    <Box
      height={height || '75vh'}
      sx={{
        '& .MuiDataGrid-root': {
          border: 'none',
        },
        '& .MuiDataGrid-cell': {
          borderBottom: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: 'primary.main',
          borderBottom: 'none',
        },
        '& .MuiDataGrid-virtualScroller': {
          backgroundColor: 'background.paper',
        },
        '& .MuiDataGrid-footerContainer': {
          borderTop: 'none',
          backgroundColor: 'primary.main',
        },
        '& .MuiCheckbox-root': {
          color: 'secondary.main !important',
        },
        ...sx,
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        checkboxSelection={checkboxSelection}
      />
    </Box>
  );
};

GeneralDataGrid.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  checkboxSelection: PropTypes.bool,
  height: PropTypes.string,
  sx: PropTypes.object,
};

export default GeneralDataGrid;